<template>
    <div class="possibilities-section container">
      <h1 class="section-title">Les possibilités qu’offre Prexange</h1>
      <div class="row">
        <div class="col-md-4 d-flex">
          <div class="card flex-fill">
            <img src="../../../../../assets/images/Multi-Device.jpg" class="card-img-top" alt="Multi-device">
            <div class="card-body">
              <h2 class="card-title">Multi-device</h2>
              <p class="card-text">
                Prexange met à votre disposition différents outils afin de vous permettre d’être à la pointe de la technologie, que vous soyez sur mobile ou sur votre ordinateur de bureau.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4 d-flex">
          <div class="card flex-fill">
            <img src="../../../../../assets/images/avantage-concurrentiel.jpg" class="card-img-top" alt="Avantages Concurrentiels">
            <div class="card-body">
              <h2 class="card-title">Avantages Concurrentiels de Prexange</h2>
              <p class="card-text">
                Prexange permet à tout courtier IOBSP d’accéder à une offre élargie de partenaires bancaires régionaux et nationaux, sans qu’il soit nécessaire d’avoir une convention en direct, …
                Principe d’appel d’offre en multi présentation simultanée : mettez à profit le temps gagné pour développer votre activité.
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-4 d-flex">
          <div class="card flex-fill">
            <img src="../../../../../assets/images/co-branding.jpg" class="card-img-top" alt="Et Plus encore !">
            <div class="card-body">
              <h2 class="card-title">Et Plus encore !</h2>
              <p class="card-text">
                Marque Blanche
                Co-Branding prescripteurs: permettez à vos partenaires prescripteurs de créer ”leurs propres services de financement” et de vous mettre en avant auprès de leurs clients.
                Tarification au succès : absence d’abonnement et d’engagement de durée.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "PossibilitiesSection",
  };
  </script>
  
  <style lang="scss">
   @import './secondService.scss'
   
   </style>
  